// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Drawer_overlay__CjqUw","content":"Drawer_content__iO836","bottom":"Drawer_bottom__6MVUD"};